import { memo, useMemo } from 'react';

import { Box, Typography, type SxProps, type Theme } from '@mui/material';

import { getProgressPercent, ProgressLinear } from './progress-linear';

interface ProcessingProgressProps {
  value?: number;
  current?: number;
  total?: number;
  sx?: SxProps<Theme>;
}

export const ProcessingProgress = memo(
  ({ value, current, total, sx }: ProcessingProgressProps) => {
    const progressPercent = useMemo(
      () => getProgressPercent(value, current, total),
      [current, total, value]
    );

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 2,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          overflow: 'hidden',
          ...sx,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            gap: 1,
            minWidth: 0,
          }}
        >
          <ProgressLinear value={progressPercent} />
          {progressPercent !== undefined ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
            >
              {`${progressPercent}%`}
            </Typography>
          ) : null}
        </Box>
      </Box>
    );
  }
);

ProcessingProgress.displayName = 'ProcessingProgress';
